<template>
    <div class="pt-2 white">
        <v-data-table :headers="headers" :items="kugeln" hide-default-footer :items-per-page="-1">
            <template v-slot:no-data>
                Es wurden noch keine Kugeln zugeordnet!
            </template>
            <template v-slot:item.tsCreated="{ item }">
                {{getDateString(item.tsCreated)}}
            </template>
             <template v-slot:item.gueltigBis="{ item }">
                {{getGueltigBis(item.gueltigBis)}}
            </template>
            <template v-slot:item.tsLastUpdated="{ item }">
                {{getDateString(item.tsLastUpdated)}}
            </template>
            <template v-slot:item.actions="{ item }">
                <div class="text-no-wrap">
                    <v-btn icon @click="editItem(item)"><v-icon>mdi-pencil</v-icon></v-btn>
                    <v-btn icon @click="deleteItem(item)"><v-icon>mdi-delete</v-icon></v-btn>
                    <v-btn icon @click="printItem(item)">
                        <span v-if="!item.waitingForPassPrint">
                            <tool-tip text="Klicken um erneut zu drucken!">
                                <v-icon>mdi-printer</v-icon>
                            </tool-tip>
                        </span>
                        <span v-else>
                            <tool-tip text="Wartet auf Druck, klicken um aus Druckliste zu entfernen!">
                                <v-icon color="warning">mdi-printer-alert</v-icon>
                            </tool-tip>
                        </span>
                    </v-btn>
                </div>
            </template>
        </v-data-table>
        <confirm-dialog :open="confirmDelete.open" header="Kugel löschen" :question="confirmDelete.question"
                        @reply="processConfirm" query-parameter="confirmKugelDelete">
            <span class="primary--text font-weight-bold" v-if="itemTemp"> {{itemTemp.nr}}</span> von
            <span class="primary--text font-weight-bold" v-if="itemTemp">{{itemTemp.ownerName}}</span>
            wirklich endgültig löschen?
        </confirm-dialog>
    </div>
</template>

<script>

import ConfirmDialog from "@/components/elements/confirmDialog";
import FirebaseWrite from "@/services/database/firebaseWrite";
import TimeStamp from "@/services/timeStamp";
import {Kugel} from "@/services/data/kugeln/kugel";
import ToolTip from "@/components/elements/toolTip";

export default {
    name: "kugel-liste",
    components: {ToolTip, ConfirmDialog},
    props: ['kugeln'],
    data: () => ({
        headers: [
            {text: 'Kugel-Nr', value: 'nr'},
            {text: 'Kommentar', value: 'kommentar'},
            {text: 'Gültig bis', value: 'gueltigBis'},
            {text: 'Erstellt am', value: 'tsCreated'},
            {text: 'Erstellt von', value: 'createdByName'},
            {text: 'Geändert am', value: 'tsLastUpdated'},
            {text: 'Geändert von', value: 'lastUpdatedByName'},
            {text: '', value: 'actions'},
        ],
        confirmDelete: {
            open: false,
            question: 'Möchtest du die Kugel',
        },
        itemTemp: null
    }),
    methods: {
        getGueltigBis(gueltigBis){
            return gueltigBis ? TimeStamp.getStringDotDateFromString(gueltigBis) : 'unbegrenzt'
        },
        getDateString(ts){
            return ts === 0 ? '-' : TimeStamp.getLocalStringFromGMTts(ts)
        },
        editItem(item){
            this.$emit('openEdit', item);
        },
        deleteItem(item){
            this.itemTemp = JSON.parse(JSON.stringify(item)) ;
            this.confirmDelete.open = true;
        },
        processConfirm(reply) {
            if ( reply ) this.processDeletion()
            this.confirmDelete.open = false
        },
        async processDeletion(){
            await FirebaseWrite.delete('kugeln', this.itemTemp.id)
            this.$emit('deleted', this.itemTemp.id);
            this.itemTemp = null
        },
        async printItem(item){
            const status = !item.waitingForPassPrint
            const kugel = new Kugel(item, null, item.ownerType, null)
            await kugel.setPrintStatus(status)
            this.$emit('reload');
        }
    },
}
</script>

<style scoped>

</style>